/**
 * @copyright 2026 @ DigiNet
 * @author YENNHI
 * @create 2026/08/25 09:25
 * @update 2026/08/25 09:25
 */

import Api from "../../../services/api";

export function loadDropDowmPeriod(params, cb) {
    return async () => {
        await Api.put('/w07f6699/load-form', params)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}

export function loadCmbDD(params, cb) {
    return async () => {
        await Api.put('/w14f1420/load-cmb-DD', params)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}

export function loadAddCol(params, cb) {
    return async () => {
        await Api.put('/w14f1420/load-add-col', params)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}

export function loadForm(params, cb) {
    return async () => {
        await Api.put('/w14f1420/load-form', params)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}
